import HomeImg from '~assets/home.svg';
import AppLogo from './assets/app_logo.svg';
import AppLogoFucam from './assets/app_logo_fucam.svg';
import AppLogoInverse from './assets/app_logo_inverse.svg';
import { BASE, FUCAM, WorkUnits } from './constants';

export const INCANS_TENANT_COLORS = {
  base: BASE,
  secretaria_salud_cali: BASE,
  demo: BASE,
  karyadb: BASE,
  elsalvador: BASE,
  fucamdb: FUCAM
};

export const INCANS_TENANT_IMAGES = {
  base: {
    logo_regular: AppLogo,
    logo_inverse: AppLogoInverse,
    landing: HomeImg
  },
  fucamdb: {
    logo_regular: AppLogo,
    logo_inverse: AppLogoFucam,
    landing: HomeImg
  }
};

export const incans_settings: ImplementationSettings = {
  colors: INCANS_TENANT_COLORS.base,
  envs: {
    google_recaptcha: import.meta.env.VITE_RECAPTCHA_KEY,
    backend_url: import.meta.env.VITE_BACKEND_URL
  },
  logos: INCANS_TENANT_IMAGES.base,
  workUnits: WorkUnits
};
